import { render, staticRenderFns } from "./selectCom.vue?vue&type=template&id=8b26b0fc&scoped=true"
import script from "./selectCom.vue?vue&type=script&lang=js"
export * from "./selectCom.vue?vue&type=script&lang=js"
import style0 from "./selectCom.vue?vue&type=style&index=0&id=8b26b0fc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b26b0fc",
  null
  
)

export default component.exports